import { getWebSocketEndpoint } from "./appRequest";

const socketRequest = (opts = {}) => {
  const {
    asyncCall,
    goalRef,
    ackId = Date.now(),
    wsProtocol = "json.webpubsub.azure.v1",
    errorLogger = (...args) => console.log(...args),
  } = opts || {};

  let setupFlag = false;
  let socketStatus = "pending";
  let socket;
  let callbacks = [];
  let socketEndpoint = "";
  let results = [];
  
  const initialAsyncCall = async (args) => {
    if (!results.length) {
      try {
        const result = await asyncCall(args);
        results.push(result);
        return Promise.resolve(result);
      } catch (err) {
        console.log('error hit', err);
        errorLogger(err);
        return Promise.reject(err);
      }
    }
  };

  const setupListeners = () => {
    if (setupFlag === true) {
      return;
    }

    setupFlag = true;

    if (socket) {
      socket.addEventListener("open", (event) => {
        socket.send(JSON.stringify({
          type: "event",
          event: "join",
          dataType: "json",
          data: {
            GoalRef: goalRef
          },
          ackId: ackId,
        }));
  
        socketStatus = "active";
      });
  
      socket.addEventListener("message", (event) => {
        const eventData = JSON.parse(event.data);
        const { data } = eventData;
  
        if (data && data.currentGoalState && data.relatedData) {
          triggerCallbacks(data);
        }
      });
  
      socket.addEventListener("error", (event) => {
        errorLogger(event);
      });
  
      socket.addEventListener("close", (event) => {
        // If we didn't explicitly close the connection we can try to reconnect
        if (socketStatus !== "closed") {
          const reconnectTimeOutId = setTimeout(() => {
            start(goalRef);
            clearTimeout(reconnectTimeOutId);
          }, 2000);
        }
      });
    }
  };

  const start = async (...initCallArgs) => { 
    if (!socketEndpoint) {
      socketEndpoint = await getWebSocketEndpoint();
    }

    if (socketEndpoint) {
      socket = new WebSocket(socketEndpoint, wsProtocol);
    } else {
      socketEndpoint = null;
      errorLogger("Socket endpoint not found, websocket not started");
    }

    if (!setupFlag) {
      setupListeners();
    }

    initialAsyncCall(...initCallArgs).then(data => {
      if (data && data.currentGoalState && data.relatedData) {
        triggerCallbacks(data);
      }
    }).catch(errorLogger);
  };

  const subscribe = async (fnc) => {
    if (typeof fnc !== "function") {
      console.warn("The argument must be a function type.");
      return;
    }

    if (results.length) {
      fnc(null, results[0]);
    }

    callbacks.push(fnc);
  };

  const stop = () => {
    socketStatus = 'closed';
    socket.close();
  };

  const triggerCallbacks = (result) => {
    for (const callback of callbacks) {
      callback(null, result);
    }
  };

  return {
    start,
    stop,
    subscribe,
    socket
  };
};

export { socketRequest };